module.exports = __webpack_public_path__ + "img/logo_login.635520c6.png";